import { Box, Container, Grid, Paper, Typography } from "@mui/material"

const skillSet = [
  {
    name: 'HTML',
    icon: 'devicon-html5-plain colored'
  },
  {
    name: 'CSS',
    icon: 'devicon-css3-plain colored'
  },
  {
    name: 'Javascript',
    icon: 'devicon-javascript-plain colored'
  },
  {
    name: 'Git',
    icon: 'devicon-git-plain colored'
  },
  {
    name: 'PHP',
    icon: 'devicon-php-plain colored'
  },
  {
    name: 'MySQL',
    icon: 'devicon-mysql-plain colored'
  },
  {
    name: 'NodeJs',
    icon: 'devicon-nodejs-plain colored'
  },
  {
    name: 'Laravel',
    icon: 'devicon-laravel-plain colored'
  },
  {
    name: 'ReactJs',
    icon: 'devicon-react-plain colored'
  },
]

const Skill = () => {
  return(
    <>
      <Box
        component="main"
        sx={{
          backgroundColor: '#1f1f1f',
          flexGrow: 1,
          py: 8
        }}
      >
        <Container maxWidth="lg">
          <Typography
            sx={{ mb: 7 }}
            variant="h4"
            align="center"
            letterSpacing= '6px' 
            textTransform= 'uppercase'
            color='#ffff'
          >
            Skills
          </Typography>
          <Grid
            container
            spacing={3}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            {
              skillSet.map((item,index) => {
                return(
                  <Grid
                    item
                    key={index}
                    lg={2}
                    md={2}
                    xs={4}
                    align="center"
                  >
                    <Paper elevation={3} style={{backgroundColor: '#424242',padding: '5px 5px 5px 5px'}}>
                      <i className={item.icon} style={{fontSize: 52}}></i>
                      <Typography variant="subtitle2" paddingTop={1} style={{color: '#fff'}}>
                        {item.name}
                      </Typography>
                    </Paper>
                  </Grid>

                )
              })
            }

          </Grid>
        </Container>
      </Box>
    </>
  )
}

export default Skill
